import React, { useState, useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Button from '@material-ui/core/Button';
import Collapse from '@material-ui/core/Collapse';
import CircularProgress from '@material-ui/core/CircularProgress';
import {
  Table,
  TableCell,
  TableBody,
  TableHead,
  TableRow,
} from '@material-ui/core';
import Abertura from './Processos/abertura';
import Alteracao from './Processos/alteracao';
import Baixa from './Processos/baixa';
import { XMEI_PRIMARY_COLOR } from '../../../consts/common';
import { instanceAxios } from '../../../InstanceAxios';

const columns = [
  { id: 'etapa', label: 'Etapa', minWidth: 140 },
  { id: 'status', label: 'Status', minWidth: 70 },
  { id: 'encerramento', label: 'Encerramento', minWidth: 140 },
  { id: 'observacao', label: 'Observação para o Cliente', minWidth: 140 },
  { id: 'observacao_interna', label: 'Observação Interna', minWidth: 140 },
];

function Etapas({ idServico, setAlert, setClose }) {
  const [aba, setAba] = useState('');
  const [abertura, setAbertura] = useState({});
  const [alteracao, setAlteracao] = useState({});
  const [baixa, setBaixa] = useState({});
  const [loading, setLoading] = useState(true);

  const getColor = (a) => (a === aba ? 'primary' : 'default');

  const handleSubmit = async () => {
    // Object.keys(empty).length === 0
    let obj;

    if (aba === 'ABERTURA') {
      obj = abertura;
      obj.tipo = aba;
      obj.id_servico_contratado = idServico;
    } else if (aba === 'ALTERACAO') {
      obj = alteracao;
      obj.tipo = aba;
      obj.id_servico_contratado = idServico;
    } else if (aba === 'BAIXA') {
      obj = baixa;
      obj.tipo = aba;
      obj.id_servico_contratado = idServico;
    } else {
      setAlert('Escolha um tipo!', 'Warning', true);
      return;
    }

    setLoading(true);
    await instanceAxios(localStorage.getItem('toobiauth'))
      .post(`/etapasServicos`, obj)
      .then((res) => {
        setAlert('Atualizado com sucesso!', 'success', true);
        setClose();
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setAlert('Erro ao atualizar etapas!', 'error', true);
        setClose();
        setLoading(false);
      });
  };

  useEffect(() => {
    const fetchEtapas = async () => {
      setLoading(true);
      await instanceAxios(localStorage.getItem('toobiauth'))
        .get(`/etapasServicos/${idServico}`)
        .then((res) => {
          let tipo = 'ABERTURA';
          if (res.data.etapasAbetura) {
            setAbertura(res.data.etapasAbetura);
            tipo = 'ABERTURA';
          }
          if (res.data.etapasAlteracao) {
            setAlteracao(res.data.etapasAlteracao);
            tipo = 'ALTERACAO';
          }
          if (res.data.etapasBaixa) {
            setBaixa(res.data.etapasBaixa);
            tipo = 'BAIXA';
          }
          setAba(tipo);
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    };

    fetchEtapas();
  }, [idServico]);

  return (
    <>
      <Collapse in={loading}>
        <Grid container direction="row" justify="center" alignItems="center">
          <CircularProgress />
        </Grid>
      </Collapse>
      <Collapse in={!loading}>
        <Grid container spacing={3}>
          <ButtonGroup
            fullWidth
            color="primary"
            aria-label="outlined primary button group"
          >
            <Button
              onClick={() => setAba('ABERTURA')}
              color={getColor('ABERTURA')}
              variant="contained"
            >
              Abertura
            </Button>
            <Button
              onClick={() => setAba('ALTERACAO')}
              color={getColor('ALTERACAO')}
              variant="contained"
            >
              Alteração
            </Button>
            <Button
              onClick={() => setAba('BAIXA')}
              color={getColor('BAIXA')}
              variant="contained"
            >
              Baixa
            </Button>
          </ButtonGroup>
        </Grid>
        <Grid container spacing={3} style={{ marginTop: '2%' }}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{
                      minWidth: column.minWidth,
                      fontWeight: 'bold',
                      textAlign: 'center',
                    }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {aba === 'ABERTURA' ? (
                <Abertura abertura={abertura} setAbertura={setAbertura} />
              ) : null}
            </TableBody>
            <TableBody>
              {aba === 'BAIXA' ? (
                <Baixa baixa={baixa} setBaixa={setBaixa} />
              ) : null}
            </TableBody>
            <TableBody>
              {aba === 'ALTERACAO' ? (
                <Alteracao alteracao={alteracao} setAlteracao={setAlteracao} />
              ) : null}
            </TableBody>
          </Table>
        </Grid>
        <Grid container direction="row" justify="center" alignItems="center">
          <Button
            variant="contained"
            style={{
              width: '40%',
              marginTop: 30,
              marginBottom: 15,
              backgroundColor: XMEI_PRIMARY_COLOR,
              color: '#FFF',
            }}
            onClick={handleSubmit}
          >
            Salvar
          </Button>
        </Grid>
      </Collapse>
    </>
  );
}

export default Etapas;
